import axios from 'axios';
import { TWILIO_HOST_NAME } from '../../../../Config';

export const verifyModelSMS = async (phone, code) => {
  const response = await axios.post(`${TWILIO_HOST_NAME}/verify_model_sms`, {
    phone,
    code
  })
  console.log(response)
}